import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { Seo, JsonLd } from "@/components/base/Seo";
import Reveal from "@/components/base/Reveal";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import LatestFeed from "@/pages/home/components/LatestFeed";
import ReversalRanking from "@/pages/home/components/ReversalRanking";
import FaqSection from "@/pages/home/components/FaqSection";
import SubmitSection from "@/pages/home/components/SubmitSection";
import { faqs, siteInfo } from "@/mocks/articles";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "17爆料网",
    alternateName: "17爆料网真假鉴定专区",
    url: "https://dahuaqi.cn/",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://dahuaqi.cn/verify?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "17爆料网",
    url: "https://dahuaqi.cn/",
    email: siteInfo.email,
    description: siteInfo.intro,
    foundingDate: siteInfo.since,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#submit") {
      const el = document.getElementById("submit");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);

  return (
    <Layout>
      <Seo
        title="17爆料网 - 真假鉴定专区 | 辟谣、反转与打脸现场追踪"
        description="17爆料网真假鉴定专区，跟踪网络传言的辟谣、反转与打脸现场，汇总当事人澄清与后续回应，帮你判断哪些料站得住，哪些已经翻车。"
        keywords="17爆料网,17爆料网真假鉴定,辟谣,反转,打脸现场,后续回应,当事人澄清"
        path="/"
      />
      <JsonLd data={jsonLd} />

      <Hero />
      <Ticker />

      <div className="mx-auto w-full max-w-7xl space-y-16 px-4 py-14 md:space-y-24 md:px-8 md:py-20">
        <Reveal>
          <CategoryGrid />
        </Reveal>
        <Reveal>
          <FeaturedSection />
        </Reveal>
        <Reveal>
          <LatestFeed />
        </Reveal>
        <Reveal>
          <ReversalRanking />
        </Reveal>
        <Reveal>
          <FaqSection />
        </Reveal>
        <Reveal>
          <SubmitSection />
        </Reveal>
      </div>
    </Layout>
  );
}